import { Reason } from "./Reason";
import { type Reason as ReasonProps } from "../types";

type CustomReasonListProps = {
  reasons: ReasonProps[];
  columns?: 2 | 3; // Allow customization of column count
};

export const CustomReasonList = ({
  reasons,
  columns = 2,
}: CustomReasonListProps) => {
  const gridClass = "grid-cols-1";

  return (
    <div
      className={`grid gap-6 ${gridClass} mb-10`}
      data-testid="custom-reason-list"
    >
      {reasons.map(({ icon, title, description }) => (
        <Reason
          key={title}
          icon={icon}
          title={title}
          description={description}
        />
      ))}
    </div>
  );
};
